<template>
  <div class="viewcharity">
      <div class="container">
          <div class="blog-section white-bg clearfix">
              <div class="row">
                  <div class="col-md-5 col-md-push-7">
                      <div class="text-left">
                          <h3 class="heading">
                              <br/>
                              <i class="nav-icon giving-icon"></i>
                              <br/><span>{{selectedCharity.name}}</span>
                          </h3>
                          <p>
                              {{selectedCharity.description}} <br>
                          </p>
                      </div>
                  </div>
                  <div class="col-md-7 col-md-pull-5">
                      <div class="panel panel-default">
                          <div class="panel-body">
                              <div class="slider responsive-slick-slider">
                                      <div class="slide-player">
                                          <img class="jw-img" :src="selectedCharity.img_url" />
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
</template>

<script>

  import { mapGetters } from 'vuex'

  export default {
      name: 'viewcharity',
      data: function () {
          return {
              selectedCharity: ''
          }
      },
      computed: {
          ...mapGetters([
              'error', 'getCharity'
          ])
      },
      mounted: function () {
          // Retreive Selected Charity
          this.$store.dispatch('GETCHARITY', this.$route.params.charityId).then(() => {
              this.selectedCharity = this.getCharity
          })
      }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Charities.vue?6ea87c1c